import { CALC_PAGE_TYPES } from 'utils/calculatorUtils';
import Results from '../../CommonViews/Results';
import CalcEmptyListBlock from '../../../components/CalcEmptyListBlock/CalcEmptyListBlock';

const Reports = ({ targetWidth }) => (
  <>
    <Results targetWidth={targetWidth} pageType={CALC_PAGE_TYPES.SUSTAINABILITY} />
  </>
);

export default Reports;
